import React from "react";
import { formImg } from "..";
import Form from "./Form";

function FormSection() {
  return (
    <div className="col-md-6 col-lg-5 pad_lr">
      <div className="formWrap">
        <div className="formHeaderSection">
          <div className="formImgWrap">
            <img src={formImg} alt="form img" className="img-fluid"/>
          </div>
          <div className="formData">
            <h5>Lois June</h5>
            <p>Cyber Expert Consultant &nbsp;
            <a href="tel:+919930809662" className="btn3">
              <span className="telPhoneIcon">
                <i className="fa fa-phone"></i>
              </span>
              +91 99308 09662
            </a></p>
          </div>
        </div>
        <div className="formInputWrap">
            <Form/>
        </div>
      </div>
    </div>
  );
}

export default FormSection;
